import { useSuspenseQuery } from '@tanstack/react-query'
import { Navigate, createFileRoute } from '@tanstack/react-router'

import { queryCompanyGet } from '@api/company/company.queries'

export const Route = createFileRoute('/app/data/companies/$uuid/(mainPage)/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { uuid } = Route.useParams()
  const { data: company } = useSuspenseQuery(queryCompanyGet(uuid))

  return (
    <Navigate
      from={Route.fullPath}
      to={company.stats.isInsured ? './insured' : './debtor'}
    />
  )
}
